import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
    fetchTakerCurrentGroup ({commit, getters, dispatch}){
        dispatch('remoteGet', {
            url: `group/${getters.currentTaker.group_uid}`
        })
        .then((res) => {
            commit('SET_TAKER_GROUP', res.data);
        });
    }
};



// WEBPACK FOOTER //
// ./src/store/actions.js